import { useNavigate } from 'react-router-dom';
import axiosInstance from '../utils/axiosInstance';
import { IconButton } from '@mui/material';
import Logout from '@mui/icons-material/Logout';

const LogoutButton = () => {
  const navigate = useNavigate();

  const logout = async () => {
    try {
      await axiosInstance.post(`/auth/logout`);
      navigate('/login', { replace: true });
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <IconButton
      color="primary"
      onClick={logout}
    ><Logout />
    </IconButton>
  );
};

export default LogoutButton;
